export const TOGGLE_MODAL = 'TOGGLE_MODAL';

export function toggleModal(modalName){
    return{
        type: TOGGLE_MODAL,
        mainState: {
            modalName: modalName
        }
    }
}